import "./MemberProfile.scss";

function DataField({ name, value, showNav, nameStyle, valueStyle, iconColor, onClick }) {
    return <div className="data-field" onClick={onClick}>
        <div className="data-name" style={nameStyle}>{name}</div>
        <div className="data-value" style={valueStyle}>{value}</div>
        {showNav && <div className="icon" role={"img"}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M5.64645 13.3536C5.45118 13.1583 5.45118 12.8417 5.64645 12.6464L10.2929 8L5.64645 3.35355C5.45118 3.15829 5.45118 2.84171 5.64645 2.64645C5.84171 2.45118 6.15829 2.45118 6.35355 2.64645L11.3536 7.64645C11.4473 7.74022 11.5 7.86739 11.5 8C11.5 8.13261 11.4473 8.25979 11.3536 8.35355L6.35355 13.3536C6.15829 13.5488 5.84171 13.5488 5.64645 13.3536Z" fill={iconColor ? iconColor : 'white'} />
            </svg>
        </div>}
    </div>
}

export default DataField